module.exports = __webpack_public_path__ + "img/paloma.3585cc99.jpg";